import React, { useEffect } from 'react';
import PageBackground from '../components/PageBackground';
import './TermsPage.css';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const imageUrl = 'https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1920&q=80';

  return (
    <div className="legal-page">
      <PageBackground imageUrl={imageUrl} />
      
      <div className="legal-page-header">
        <div className="container">
          <h1>Terms & Privacy Policy</h1>
          <p>Last Updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </div>

      <div className="legal-main-content">
        <div className="container legal-text-container">

          {/* --- LEGAL ENTITY DECLARATION FOR META/BUSINESS VERIFICATION --- */}
          <div style={{ marginBottom: '3rem', padding: '1.5rem', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid var(--primary-color)' }}>
            <p style={{ margin: 0, fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Legal Entity Declaration:</strong> The platform "Anandmaya" (accessible via anandmaya.net and associated applications) is wholly owned and operated by <strong>MAHAV TECHNOLOGIES LLP</strong>. Throughout these Terms and Conditions and Privacy Policy, references to "we," "us," "our," or "the Company" refer to MAHAV TECHNOLOGIES LLP.
            </p>
          </div>
          {/* --------------------------------------------------------------- */}

          {/* ========================================== */}
          {/* PART A: TERMS AND CONDITIONS               */}
          {/* ========================================== */}
          <section>
            <h2>PART A: Terms and Conditions</h2>
            
            <h3>1. Acceptance of Terms</h3>
            <p>By accessing, registering, or making a payment on this website, you agree to be legally bound by these Terms and Conditions. If you do not agree, you must not use this platform.</p>

            <h3>2. Services Offered</h3>
            <p>We provide online services and platform for spiritual and personal wellbeing and an e-commerce page (Bhakti Store) providing products for personal use. We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.</p>
            
            <h3>3. User Eligibility</h3>
            <ul>
              <li>Users must be at least 18 years old or legally competent to enter into contracts.</li>
              <li>By using this website, you confirm that all information provided is accurate and complete.</li>
            </ul>

            <h3>4. Account Responsibility</h3>
            <ul>
              <li>You are responsible for maintaining confidentiality of your account credentials.</li>
              <li>Any activity under your account will be considered your responsibility.</li>
              <li>We are not liable for unauthorized access due to your negligence.</li>
            </ul>

            <h3>5. Payment Terms</h3>
            <ul>
                <li>All payments must be made through approved payment gateways.</li>
                <li>Prices are subject to change without prior notice.</li>
                <li>Payment once made is considered <strong>final and binding</strong>, except as stated in the refund policy.</li>
                <li>We are not responsible for payment failures due to bank, network, or third-party gateway issues.</li>
            </ul>

            <h3>6. Refund & Cancellation Policy</h3>
            <ul>
                <li>Services and products once sold cannot be cancelled.</li>
                <li>Refunds will only be processed under specific conditions as defined by us.</li>
                <li>No refunds will be provided for:
                  <ul>
                    <li>Change of mind</li>
                    <li>Incorrect service selection by the user</li>
                    <li>Partial usage of services</li>
                  </ul>
                </li>
                <li>We reserve the right to approve or reject refund requests at our sole discretion.</li>
            </ul>

            <h3>7. Service Delivery Disclaimer</h3>
            <ul>
              <li>We strive to deliver services as described; however:
                <ul>
                  <li>Results may vary based on user input, external factors, or third-party dependencies.</li>
                  <li>We do not guarantee specific outcomes unless explicitly stated in writing.</li>
                </ul>
              </li>
            </ul>

            <h3>8. User Obligations</h3>
            <p>You agree NOT to:</p>
            <ul>
              <li>Misuse or exploit the platform</li>
              <li>Provide false, misleading, or fraudulent information</li>
              <li>Attempt to reverse engineer, hack, or disrupt services</li>
              <li>Use the service for unlawful purposes</li>
            </ul>

            <h3>9. Intellectual Property</h3>
            <ul>
              <li>All content, branding, and materials on this website are owned by us.</li>
              <li>Users are prohibited from copying, distributing, or reproducing any content without written permission.</li>
            </ul>

            <h3>10. Limitation of Liability</h3>
            <ul>
              <li>We shall not be liable for:
                <ul>
                  <li>Any indirect, incidental, or consequential damages</li>
                  <li>Loss of data, revenue, or profits</li>
                  <li>Service interruptions or technical failures</li>
                </ul>
              </li>
              <li>Maximum liability shall not exceed the amount paid by the user for the service.</li>
            </ul>

            <h3>11. Third-Party Services</h3>
            <ul>
              <li>We may use third-party providers (payment gateways, APIs, etc.).</li>
              <li>We are not responsible for their actions, downtime, or errors.</li>
            </ul>

            <h3>12. Indemnification</h3>
            <p>You agree to indemnify and hold harmless the company from any claims, losses, damages, or legal fees arising due to:</p>
            <ul>
              <li>Your misuse of the platform</li>
              <li>Violation of these terms</li>
              <li>Fraudulent or illegal activities</li>
            </ul>

            <h3>13. Fraud Prevention & Right to Refuse Service</h3>
            <ul>
              <li>We reserve the right to:
                <ul>
                  <li>Cancel suspicious transactions</li>
                  <li>Block users without prior notice</li>
                  <li>Report fraudulent activity to authorities</li>
                </ul>
              </li>
            </ul>

            <h3>14. Force Majeure</h3>
            <p>We shall not be liable for delays or failures caused by events beyond our control, including but not limited to:</p>
            <ul>
              <li>Natural disasters</li>
              <li>Government actions</li>
              <li>Geopolitical conflicts</li>
              <li>Network failures</li>
              <li>Cyber attacks</li>
            </ul>

            <h3>15. Termination</h3>
            <p>We reserve the right to suspend or terminate your access:</p>
            <ul>
              <li>Without notice if you violate these terms</li>
              <li>If required by law</li>
            </ul>

            <h3>16. Governing Law & Jurisdiction</h3>
            <ul>
              <li>These terms shall be governed by the laws of <strong>India</strong>.</li>
              <li>Any disputes shall be subject to the jurisdiction of courts in <strong>Bhubaneswar, Odisha, India</strong>.</li>
            </ul>

            <h3>17. Dispute Resolution</h3>
            <ul>
              <li>Users agree to first attempt resolution through negotiation.</li>
              <li>If unresolved, disputes may be referred to arbitration as per applicable laws.</li>
            </ul>

            <h3>18. Changes to Terms</h3>
            <p>We may update these Terms at any time. Continued use of the platform constitutes acceptance of updated terms.</p>

            <h3>19. Contact Information</h3>
            <p>For any queries:</p>
            <ul>
              <li>Email: info@anandmaya.net</li>
              <li>Phone: +91-7790094555</li>
              <li>Address: Plot No- 274/3636, Mahadev Nagar, Laxmisagar (Khorda), Laxmisagar Police Station, Bhubaneswar, Khorda- 751006, Orissa, India</li>
            </ul>

            <h3>20. Acknowledgment</h3>
            <p>By using this website and making a payment, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.</p>

            <h3>21. No Chargeback Abuse & Payment Disputes</h3>
            <ol>
              <li>By making a payment on this platform, you agree <strong>not to initiate any chargeback, reversal, or payment dispute</strong> with your bank or payment provider without first contacting us and attempting to resolve the issue.</li>
              <li>In the event a chargeback is initiated:
                <ul>
                  <li>You agree that such action shall be considered a <strong>breach of these Terms and Conditions</strong>.</li>
                  <li>We reserve the right to <strong>suspend or permanently terminate your account</strong> without prior notice.</li>
                  <li>Any ongoing or future services associated with your account may be immediately discontinued.</li>
                </ul>
              </li>
              <li>You agree to provide valid proof and cooperate in resolving disputes raised. Failure to do so may result in permanent restriction from using our services.</li>
              <li>If a chargeback is found to be <strong>fraudulent, abusive, or without valid justification</strong>, we reserve the right to:
                <ul>
                  <li>Recover the disputed amount along with any applicable <strong>processing fees, penalties, and legal costs</strong>.</li>
                  <li>Initiate <strong>legal proceedings</strong> under applicable laws.</li>
                  <li>Report such activity to payment processors, banks, and regulatory authorities.</li>
                </ul>
              </li>
              <li>You acknowledge that:
                <ul>
                  <li>Services once delivered or initiated are <strong>non-reversible and non-refundable</strong>, unless explicitly stated.</li>
                  <li>Chargebacks for services already rendered will be treated as <strong>unlawful enrichment and misuse of payment systems</strong>.</li>
                </ul>
              </li>
              <li>We maintain detailed records including but not limited to:
                <ul>
                  <li>IP address logs</li>
                  <li>Payment confirmations</li>
                  <li>Service usage logs</li>
                  <li>Communication records</li>
                </ul>
                These may be used as evidence in dispute resolution or legal proceedings.
              </li>
              <li>The burden of proof for any unauthorized transaction claim lies with the user, and you agree to fully cooperate in any investigation.</li>
              <li>We reserve the right to engage <strong>collection agencies or legal counsel</strong> to recover outstanding dues arising from chargebacks.</li>
            </ol>
          </section>

          <hr className="section-divider" />

          {/* ========================================== */}
          {/* PART B: PRIVACY POLICY                     */}
          {/* ========================================== */}
          <section>
            <h2>PART B: PRIVACY POLICY</h2>

            <h3>1. Introduction</h3>
            <p>This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our website and services.</p>

            <h3>2. Information We Collect</h3>
            <p>We may collect the following types of data:</p>
            <p><strong>a. Personal Information</strong></p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Billing address</li>
            </ul>
            <p><strong>b. Payment Information</strong></p>
            <ul>
              <li>Payment details are processed securely via third-party payment gateways.</li>
              <li>We do NOT store card details.</li>
            </ul>
            <p><strong>c. Technical Information</strong></p>
            <ul>
              <li>IP address</li>
              <li>Browser type</li>
              <li>Device information</li>
              <li>Cookies and usage data</li>
            </ul>

            <h3>3. How We Use Your Information</h3>
            <p>We use your data to:</p>
            <ul>
              <li>Provide and deliver services</li>
              <li>Process payments</li>
              <li>Communicate updates and support</li>
              <li>Improve user experience</li>
              <li>Prevent fraud and abuse</li>
            </ul>

            <h3>4. Legal Basis for Processing</h3>
            <p>We process your data based on:</p>
            <ul>
              <li>Your consent</li>
              <li>Contractual necessity</li>
              <li>Legal compliance</li>
              <li>Legitimate business interests</li>
            </ul>

            <h3>5. Data Sharing & Disclosure</h3>
            <p>We may share your data with:</p>
            <ul>
              <li>Payment gateways</li>
              <li>Service providers and vendors</li>
              <li>Legal authorities (if required by law)</li>
            </ul>
            <p>We do NOT sell or rent your personal data.</p>

            <h3>6. Data Security</h3>
            <p>We implement reasonable technical and organizational measures to protect your data. However, no system is completely secure.</p>

            <h3>7. Cookies Policy</h3>
            <ul>
              <li>We use cookies to enhance user experience.</li>
              <li>You can disable cookies via browser settings, but some features may not function properly.</li>
            </ul>

            <h3>8. Data Retention</h3>
            <p>We retain user data:</p>
            <ul>
              <li>As long as necessary for service delivery</li>
              <li>As required by law</li>
              <li>For dispute resolution and fraud prevention</li>
            </ul>

            <h3>9. User Rights</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access your data</li>
              <li>Correct inaccuracies</li>
              <li>Request deletion (subject to legal obligations)</li>
              <li>Withdraw consent</li>
            </ul>

            <h3>10. Third-Party Links</h3>
            <p>Our website may contain links to third-party websites. We are not responsible for their privacy practices.</p>

            <h3>11. Children’s Privacy</h3>
            <p>Our services are not intended for individuals under 18 years of age.</p>

            <h3>12. Limitation of Liability (Privacy)</h3>
            <p>We are not liable for:</p>
            <ul>
              <li>Data breaches caused by third-party systems</li>
              <li>Unauthorized access beyond reasonable control</li>
            </ul>

            <h3>13. Updates to Privacy Policy</h3>
            <p>We may update this Privacy Policy periodically. Continued use implies acceptance.</p>

            <h3>14. Contact for Privacy Concerns</h3>
            <p>Email: info@anandmaya.net</p>

            <h3>15. Consent</h3>
            <p>By using this website, you consent to the collection and use of your information as outlined in this Privacy Policy.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsPage;